@use 'sass:map';

@use '../../../scss/tokens/font-weights';
@use '../../../scss/global/spacing';
@use '../../../scss/global/border';
@use '../../../scss/global/color';
@use '../../../scss/tokens/line-heights';

@use './dropdown.mixins' as mixins;
@use './dropdown.vars' as *;

.fds-dropdown {
  position: relative;

  @include mixins.dropdown-text;

  &__label {
    font-weight: map.get(font-weights.$default, content-text-common-font-weight-2);
    color: var(--text-color);
  }

  &__required {
    color: var(--required-asterisk-color);
    margin-left: spacing.$spacer-3;
  }

  &__description {
    display: flex;
    gap: spacing.$spacer-1;
    align-items: center;
    color: var(--text-description-color);
  }

  &__container {
    position: relative;
    display: flex;
    overflow: hidden;
    border-radius: border.$radius-1;
    background-color: var(--background-color-default);

    &-error-icon {
      position: absolute;
      left: spacing.$spacer-2;
      top: 50%;
      transform: translateY(-50%);
      color: var(--icon-color);
    }

    &-expand-icon {
      position: absolute;
      right: spacing.$spacer-3;
      top: 50%;
      transform: translateY(-50%);
      color: var(--icon-color);
    }

    @include mixins.dropdown-not-focus-within;
  }

  &__select {
    appearance: none;
    outline: none;
    flex: 1;
    align-items: center;
    overflow: hidden;
    border: none;
    padding: spacing.$spacer-2;
    background-color: var(--fds-color-common-transparent100, color.$default-transparent);

    @include mixins.dropdown-text;

    line-height: map.get(line-heights.$default, size-text-common-line-height-5);

    &--withIcon {
      padding-left: spacing.$spacer-10;
    }

    &--placeholder {
      color: var(--text-placeholder-color);
    }
  }
}

@include mixins.dropdown-hover;
@include mixins.dropdown-disabled;
@include mixins.dropdown-focus;
